// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.so0eikyuKlhEBRZ7aglq {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background: linear-gradient(
    116.81deg,
    rgba(3, 120, 209, 0.25) -7.65%,
    rgba(255, 255, 255, 0.25) 71.29%
  );
}

.yz4WCKc_95Ylc92cKZe3 {
  display: flex;
  flex: 1 1 0%;
  align-items: center;
  justify-content: center;
}

.kpDUfCW7GXcuuQS3dqha {
  min-height: 423px;
  width: 100%;
  max-width: 531px;
  border-radius: 5px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
  padding: 2rem;
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  background: linear-gradient(
    110.41deg,
    rgba(255, 255, 255, 0.67) -1.18%,
    rgba(255, 255, 255, 0.62) 98.72%
  );
}

.Mg7RAtsYnCfqlKdHVdQm {
  display: flex;
  justify-content: center;
}

.DOFI0kyZHtbv2fUHdiee {
  height: 3rem;
  width: 289px;
}

.UJ7tERCguz0pTBhZS2xD {
  text-align: center;
  font-family: Noto Sans;
  font-size: 35px;
  font-weight: 700;
}

.iLcJIa5_M300wwmjZfev {
  margin-bottom: 1.5rem;
  display: flex;
  justify-content: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

.OdmEmjC9ryV6tL7daTak {
  display: flex;
  gap: 1rem;
}

.xqyoE03docDY0sBV4CbQ {
  margin-bottom: 17px;
  width: 40%;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

.aSYkPcDIGqSYcZszfOH9 {
  margin-right: 0.25rem;
  height: 17px;
  width: 14px;
}

.NqBKdqjrPBE4Hmu37RRH {
  margin-bottom: 30px;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

.VZFC4UYuaJOqsnK8wFfC {
  margin-right: 0.25rem;
  height: 14px;
  width: 14px;
}

.fFerxqdH_RLueJ9GQ1Ad {
  margin-bottom: 17px;
  flex: 1 1 0%;
  font-family: Noto Sans;
  font-size: 16px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

.M_6zsgo5nnfmXCSzxgyd {
  margin-right: 0.25rem;
  height: 16px;
  width: 16px;
}

.hg1c2YleX_MRAyxJRzny {
  display: flex;
  width: 100%;
  justify-content: space-between;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
}

.JWEsQDLrYVrskbaTr8Pv {
  display: flex;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
  align-items: center;
  gap: 0.25rem;
  font-family: Noto Sans;
  font-size: 12px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1));
}

.JWEsQDLrYVrskbaTr8Pv:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(3 120 209 / var(--tw-text-opacity, 1)) !important;
}

.uXM0gW9q0gKCO5C6_VdB {
  margin-bottom: 0px !important;
}

.L9Zrd9g7R2HLmeMJKqur {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  font-size: 16px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.L9Zrd9g7R2HLmeMJKqur:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.pxe2iiKoBXsGYWpPddZ7 {
  margin-top: 2rem;
  margin-bottom: 2rem;
  display: flex;
  justify-content: center;
  gap: 1.25rem;
}

.RCs1Vxb0P6VrvMT3nlN3 {
  height: 50px;
  width: 50px;
  border-radius: 6px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(149 149 149 / var(--tw-border-opacity, 1));
  text-align: center;
  font-size: 22px;
}

.RCs1Vxb0P6VrvMT3nlN3 input {
  text-align: center;
}

.RCs1Vxb0P6VrvMT3nlN3:focus,
.RCs1Vxb0P6VrvMT3nlN3:hover,
.RCs1Vxb0P6VrvMT3nlN3.yllgE9Q9bm9JhGizrPjR {
  --tw-border-opacity: 1;
  border-color: rgb(3 120 209 / var(--tw-border-opacity, 1));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.Ymd7__gRvKVw1TyKx4hD {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(0 130 202 / var(--tw-bg-opacity, 1)) !important;
  font-size: 16px;
  font-weight: 500;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.Ymd7__gRvKVw1TyKx4hD:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.ER2x0InOdkkGRLOvvnx7 {
  display: flex;
  align-items: center;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.WbudhKSOO9Us5LEKK6Yx {
  flex-grow: 1;
  border-top-width: 1px;
  --tw-border-opacity: 1 !important;
  border-color: rgb(217 217 217 / var(--tw-border-opacity, 1)) !important;
}

.xfZonP5gDozwlgsRFDxh {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(149 149 149 / var(--tw-text-opacity, 1));
}

.qJW2Us25yGRJn6KNGtE_ {
  height: 50px;
  width: 100%;
  border-radius: 5px;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(244 49 49 / var(--tw-bg-opacity, 1)) !important;
  font-size: 16px;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.qJW2Us25yGRJn6KNGtE_:hover {
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1)) !important;
}

.okMugYDZkSZfngt_eR2L .ant-btn,
.okMugYDZkSZfngt_eR2L .ant-btn:hover {
  --tw-border-opacity: 1 !important;
  border-color: rgb(244 49 49 / var(--tw-border-opacity, 1)) !important;
}

.goyiYXkSg7SQ9SCO33PQ {
  margin-top: 1rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 14px;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

.i4fRdC_efSQuO2p8onZd {
  font-size: 12px;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(0 130 202 / var(--tw-text-opacity, 1));
}

.hh0pAoTOddmFQi0_2F91 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.Q_kKfaXPWmEe_0WhPo05 {
  height: 1rem;
  width: auto;
}

.pEdv73oVz21AySfQE6vq {
  display: flex;
  min-height: 600px;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.fFndUtyfnpAHpziKLB6P {
  margin-bottom: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  font-family: Noto Sans;
  font-size: 14px;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(47 47 47 / var(--tw-text-opacity, 1));
}

.c_RDCJj5OlFPZSUQwRmr {
  display: block;
  word-break: break-all;
  font-size: 14px;
  font-weight: 400;
}

.WgClFQu9os_Vu2AR01QA {
  margin-top: 0.5rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ChJJL79gFYWK2MVlnew9 {
  display: flex;
  height: 30px;
  width: 100%;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background-color: #daebf94a !important;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0px;
  padding-bottom: 0px;
}

.mcGbb2X5e5QZjbf6Tye_ {
  font-size: 11px;
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity, 1));
}

.XyUusWTgFOHkpsTU6IJy {
  cursor: not-allowed;
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Login.module.css"],"names":[],"mappings":"AACE;EAAA,aAAiC;EAAjC,iBAAiC;EAAjC,sBAAiC;EACjC;;;;;AADiC;;AASjC;EAAA,aAA8C;EAA9C,YAA8C;EAA9C,mBAA8C;EAA9C;AAA8C;;AAI9C;EAAA,iBAA8E;EAA9E,WAA8E;EAA9E,gBAA8E;EAA9E,kBAA8E;EAA9E,kBAA8E;EAA9E,4DAA8E;EAA9E,aAA8E;EAA9E,+EAA8E;EAA9E,mGAA8E;EAA9E,uGAA8E;EAC9E;;;;;AAD8E;;AAS9E;EAAA,aAA0B;EAA1B;AAA0B;;AAI1B;EAAA,YAAqB;EAArB;AAAqB;;AAIrB;EAAA,kBAAmD;EAAnD,sBAAmD;EAAnD,eAAmD;EAAnD;AAAmD;;AAInD;EAAA,qBAA+F;EAA/F,aAA+F;EAA/F,uBAA+F;EAA/F,mBAA+F;EAA/F,sBAA+F;EAA/F,kBAA+F;EAA/F,sBAA+F;EAA/F,eAA+F;EAA/F,gBAA+F;EAA/F,oBAA+F;EAA/F;AAA+F;;AAI/F;EAAA,aAAiB;EAAjB;AAAiB;;AAIjB;EAAA,mBAAyE;EAAzE,UAAyE;EAAzE,sBAAyE;EAAzE,eAAyE;EAAzE,gBAAyE;EAAzE,oBAAyE;EAAzE;AAAyE;;AAIzE;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;;AAI7B;EAAA,mBAAiE;EAAjE,sBAAiE;EAAjE,eAAiE;EAAjE,gBAAiE;EAAjE,oBAAiE;EAAjE;AAAiE;;AAIjE;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;;AAI7B;EAAA,mBAAwE;EAAxE,YAAwE;EAAxE,sBAAwE;EAAxE,eAAwE;EAAxE,gBAAwE;EAAxE,oBAAwE;EAAxE;AAAwE;;AAIxE;EAAA,qBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;;AAI7B;EAAA,aAA0E;EAA1E,WAA0E;EAA1E,8BAA0E;EAA1E,sBAA0E;EAA1E,eAA0E;EAA1E;AAA0E;;AAI1E;EAAA,aAAqH;EAArH,uBAAqH;EAArH,kBAAqH;EAArH,eAAqH;EAArH,mBAAqH;EAArH,YAAqH;EAArH,sBAAqH;EAArH,eAAqH;EAArH,gBAAqH;EAArH,oBAAqH;EAArH;AAAqH;;AAArH;EAAA,+BAAqH;EAArH;AAAqH;;AAIrH;EAAA;AAAY;;AAIZ;EAAA,YAA8G;EAA9G,WAA8G;EAA9G,kBAA8G;EAA9G,6BAA8G;EAA9G,qEAA8G;EAA9G,eAA8G;EAA9G,gBAA8G;EAA9G,oBAA8G;EAA9G;AAA8G;;AAA9G;EAAA,+BAA8G;EAA9G;AAA8G;;AAI9G;EAAA,gBAA0C;EAA1C,mBAA0C;EAA1C,aAA0C;EAA1C,uBAA0C;EAA1C;AAA0C;;AAI1C;EAAA,YAAqF;EAArF,WAAqF;EAArF,kBAAqF;EAArF,iBAAqF;EAArF,sBAAqF;EAArF,4DAAqF;EAArF,kBAAqF;EAArF;AAAqF;;AAGvF;EACE,kBAAkB;AACpB;;AAKE;;;EAAA,sBAA8C;EAA9C,0DAA8C;EAA9C,sBAA8C;EAA9C,8BAA8C;EAA9C,uGAA8C;EAA9C,8BAA8C;EAA9C;AAA8C;;AAI9C;EAAA,YAA+G;EAA/G,WAA+G;EAA/G,kBAA+G;EAA/G,6BAA+G;EAA/G,qEAA+G;EAA/G,eAA+G;EAA/G,gBAA+G;EAA/G,+BAA+G;EAA/G;AAA+G;;AAA/G;EAAA,+BAA+G;EAA/G;AAA+G;;AAI/G;EAAA,aAA6B;EAA7B,mBAA6B;EAA7B,mBAA6B;EAA7B;AAA6B;;AAI7B;EAAA,YAA0C;EAA1C,qBAA0C;EAA1C,iCAA0C;EAA1C;AAA0C;;AAI1C;EAAA,mBAAyB;EAAzB,oBAAyB;EAAzB,oBAAyB;EAAzB;AAAyB;;AAIzB;EAAA,YAA+G;EAA/G,WAA+G;EAA/G,kBAA+G;EAA/G,6BAA+G;EAA/G,qEAA+G;EAA/G,eAA+G;EAA/G,gBAA+G;EAA/G,oBAA+G;EAA/G;AAA+G;;AAA/G;EAAA,+BAA+G;EAA/G;AAA+G;;AAK/G;;EAAA,iCAAyB;EAAzB;AAAyB;;AAIzB;EAAA,gBAA0D;EAA1D,kBAA0D;EAA1D,sBAA0D;EAA1D,eAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;;AAI1D;EAAA,eAA2C;EAA3C,gBAA2C;EAA3C,oBAA2C;EAA3C;AAA2C;;AAI3C;EAAA,aAA8B;EAA9B,mBAA8B;EAA9B;AAA8B;;AAI9B;EAAA,YAAiB;EAAjB;AAAiB;;AAIjB;EAAA,aAA4D;EAA5D,iBAA4D;EAA5D,WAA4D;EAA5D,mBAA4D;EAA5D;AAA4D;;AAI5D;EAAA,qBAA4H;EAA5H,aAA4H;EAA5H,eAA4H;EAA5H,mBAA4H;EAA5H,uBAA4H;EAA5H,YAA4H;EAA5H,mBAA4H;EAA5H,sBAA4H;EAA5H,kBAA4H;EAA5H,sBAA4H;EAA5H,eAA4H;EAA5H,gBAA4H;EAA5H,oBAA4H;EAA5H;AAA4H;;AAI5H;EAAA,cAAqD;EAArD,qBAAqD;EAArD,eAAqD;EAArD;AAAqD;;AAIrD;EAAA,kBAAkD;EAAlD,qBAAkD;EAAlD,aAAkD;EAAlD,mBAAkD;EAAlD;AAAkD;;AAIlD;EAAA,aAA+F;EAA/F,YAA+F;EAA/F,WAA+F;EAA/F,cAA+F;EAA/F,mBAA+F;EAA/F,uBAA+F;EAA/F,sCAA+F;EAA/F,oBAA+F;EAA/F,qBAA+F;EAA/F,gBAA+F;EAA/F;AAA+F;;AAI/F;EAAA,eAAiC;EAAjC,oBAAiC;EAAjC;AAAiC;;AAGnC;EACE,mBAAmB;EACnB,YAAY;AACd","sourcesContent":[".gradientBg {\n  @apply flex flex-col min-h-screen;\n  background: linear-gradient(\n    116.81deg,\n    rgba(3, 120, 209, 0.25) -7.65%,\n    rgba(255, 255, 255, 0.25) 71.29%\n  );\n}\n\n.loginWrapper {\n  @apply flex-1 flex items-center justify-center;\n}\n\n.formContainer {\n  @apply bg-white rounded-[5px] shadow-lg p-8 w-full max-w-[531px] min-h-[423px];\n  background: linear-gradient(\n    110.41deg,\n    rgba(255, 255, 255, 0.67) -1.18%,\n    rgba(255, 255, 255, 0.62) 98.72%\n  );\n}\n\n.logo {\n  @apply flex justify-center;\n}\n\n.logoImage {\n  @apply w-[289px] h-12;\n}\n\n.loginHeading {\n  @apply text-[35px] font-bold text-center font-inter;\n}\n\n.loginSubTitle {\n  @apply font-inter text-gray-500 font-button text-body py-2 mb-6 flex text-center justify-center;\n}\n\n.gridForm {\n  @apply flex gap-4;\n}\n\n.tenantCode {\n  @apply w-[40%] text-gray-500 font-inter font-button text-button mb-[17px];\n}\n\n.tenantIcon {\n  @apply w-[14px] h-[17px] mr-1;\n}\n\n.userId {\n  @apply text-gray-500 font-inter font-button text-button mb-[30px];\n}\n\n.userIcon {\n  @apply w-[14px] h-[14px] mr-1;\n}\n\n.password {\n  @apply flex-1 text-gray-500 font-inter font-button text-button mb-[17px];\n}\n\n.passwordIcon {\n  @apply w-[16px] h-[16px] mr-1;\n}\n\n.RememberMe {\n  @apply flex justify-between text-dashboardMain font-body font-inter w-full;\n}\n\n.forgotPassword {\n  @apply text-primary hover:!text-primary text-[12px] font-inter font-bold cursor-pointer w-fit flex items-center gap-1;\n}\n\n.login {\n  @apply !mb-0;\n}\n\n.submitButton {\n  @apply !bg-secondary w-full h-[50px] text-button font-dashboardMain text-white rounded-[5px] hover:!text-white;\n}\n\n.otpContainer {\n  @apply flex justify-center gap-5 mt-8 mb-8;\n}\n\n.otpInput {\n  @apply w-[50px] h-[50px] text-center text-[22px] rounded-[6px] border border-gray-300;\n}\n\n.otpInput input {\n  text-align: center;\n}\n\n.otpInput:focus,\n.otpInput:hover,\n.otpInput.ant-input-focused {\n  @apply border-primary shadow-none outline-none;\n}\n\n.verifyOtpButton {\n  @apply !bg-secondary !text-white w-full h-[50px] text-button font-dashboardMain rounded-[5px] hover:!text-white;\n}\n\n.or {\n  @apply flex items-center py-2;\n}\n\n.customLine {\n  @apply flex-grow border-t !border-gray-100;\n}\n\n.orText {\n  @apply mx-2 text-gray-300;\n}\n\n.dangerButton {\n  @apply !bg-danger-100 w-full h-[50px] text-button font-dashboardMain text-white rounded-[5px] hover:!text-white;\n}\n\n.singpassContainer :global(.ant-btn),\n.singpassContainer :global(.ant-btn:hover) {\n  @apply !border-danger-100;\n}\n\n.footer {\n  @apply text-center text-body text-gray-500 mt-4 font-inter;\n}\n\n.customTag {\n  @apply text-secondary font-bold text-[12px];\n}\n\n.singpassContent {\n  @apply flex items-center gap-2;\n}\n\n.singpassLogo {\n  @apply h-4 w-auto;\n}\n\n.spinWrapper {\n  @apply flex justify-center items-center w-full min-h-[600px];\n}\n\n.otpLoginSubTitle {\n  @apply font-inter text-gray-500 font-button text-body py-2 mb-6 flex items-center justify-center gap-1 flex-wrap text-center;\n}\n\n.otpEmail {\n  @apply block font-normal text-dashboardMain break-all;\n}\n\n.remember {\n  @apply flex justify-between items-center mt-2 mb-6;\n}\n\n.appFooter {\n  @apply w-full flex items-center flex-shrink-0 justify-center h-[30px] px-6 py-0 !bg-[#daebf94a];\n}\n\n.appFooterText {\n  @apply text-slate-600 text-[11px];\n}\n\n.disabledResend {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gradientBg": `so0eikyuKlhEBRZ7aglq`,
	"loginWrapper": `yz4WCKc_95Ylc92cKZe3`,
	"formContainer": `kpDUfCW7GXcuuQS3dqha`,
	"logo": `Mg7RAtsYnCfqlKdHVdQm`,
	"logoImage": `DOFI0kyZHtbv2fUHdiee`,
	"loginHeading": `UJ7tERCguz0pTBhZS2xD`,
	"loginSubTitle": `iLcJIa5_M300wwmjZfev`,
	"gridForm": `OdmEmjC9ryV6tL7daTak`,
	"tenantCode": `xqyoE03docDY0sBV4CbQ`,
	"tenantIcon": `aSYkPcDIGqSYcZszfOH9`,
	"userId": `NqBKdqjrPBE4Hmu37RRH`,
	"userIcon": `VZFC4UYuaJOqsnK8wFfC`,
	"password": `fFerxqdH_RLueJ9GQ1Ad`,
	"passwordIcon": `M_6zsgo5nnfmXCSzxgyd`,
	"RememberMe": `hg1c2YleX_MRAyxJRzny`,
	"forgotPassword": `JWEsQDLrYVrskbaTr8Pv`,
	"login": `uXM0gW9q0gKCO5C6_VdB`,
	"submitButton": `L9Zrd9g7R2HLmeMJKqur`,
	"otpContainer": `pxe2iiKoBXsGYWpPddZ7`,
	"otpInput": `RCs1Vxb0P6VrvMT3nlN3`,
	"ant-input-focused": `yllgE9Q9bm9JhGizrPjR`,
	"verifyOtpButton": `Ymd7__gRvKVw1TyKx4hD`,
	"or": `ER2x0InOdkkGRLOvvnx7`,
	"customLine": `WbudhKSOO9Us5LEKK6Yx`,
	"orText": `xfZonP5gDozwlgsRFDxh`,
	"dangerButton": `qJW2Us25yGRJn6KNGtE_`,
	"singpassContainer": `okMugYDZkSZfngt_eR2L`,
	"footer": `goyiYXkSg7SQ9SCO33PQ`,
	"customTag": `i4fRdC_efSQuO2p8onZd`,
	"singpassContent": `hh0pAoTOddmFQi0_2F91`,
	"singpassLogo": `Q_kKfaXPWmEe_0WhPo05`,
	"spinWrapper": `pEdv73oVz21AySfQE6vq`,
	"otpLoginSubTitle": `fFndUtyfnpAHpziKLB6P`,
	"otpEmail": `c_RDCJj5OlFPZSUQwRmr`,
	"remember": `WgClFQu9os_Vu2AR01QA`,
	"appFooter": `ChJJL79gFYWK2MVlnew9`,
	"appFooterText": `mcGbb2X5e5QZjbf6Tye_`,
	"disabledResend": `XyUusWTgFOHkpsTU6IJy`
};
export default ___CSS_LOADER_EXPORT___;
